// extracted by mini-css-extract-plugin
module.exports = {"default":"ButtonPrimary_default__2Mbr8","inverse":"ButtonPrimary_inverse__9FZvk","disabled":"ButtonPrimary_disabled__3xXRf"};